import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { RenameFolderByIdRequest, RenameFolderByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useRenameFolderMutation(
  pathVariable: Pick<RenameFolderByIdRequest, "folderId">,
  options?: SimpleMutationOptions<RenameFolderByIdResponse, RenameFolderByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderUrl.renameFolderById(pathVariable.folderId),
    },
    ...options,
  });
}
